<template>
  <v-dialog v-model="dialog" max-width="750" persistent transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat dark color="secondary">
          <v-toolbar-title>Penentuan Prioritas KS dengan nilai yang sama</v-toolbar-title>
          <v-spacer />
          <v-btn right icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pb-0 black--text my-5">
        <list-kasek
          v-if="detail && detail.psp_peringkat_jenjang_id"
          ref="kasek"
          :kasek="kasek"
          :detail="detail || {}"
          type="set-peringkat"
        />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small text @click="close">
          Batal
        </v-btn>
        <v-btn class="ma-2" color="primary" elevation="1" @click="save">
          Simpan
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import ListKasek from '../../base/ListKasek';

export default {
  name: 'PopupPeringkat',
  components: { ListKasek },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    kasek: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      dialog: false,
      form: {},
    };
  },

  methods: {
    ...mapActions('peringkat', ['index']),

    getInfoSekolah(data, key) {
      const isSesuai = Number(data.is_sesuai) === 1;
      const sekolahAwal = this.$getDeepObj(data, 'ptk_kasek.ptk_tugases.0.sekolah') || {};
      const sekolahVerval = this.$getDeepObj(data, 'sekolah') || {};

      if (isSesuai) {
        return sekolahVerval[key] || '-';
      }

      return sekolahAwal[key] || '-';
    },

    getParams() {
      return {
        nilai_sama: this.kasek.nilai_sama || '',
        is_negeri: this.kasek.is_negeri,
        kandidats: this.$refs.kasek.getPeringkat(),
      };
    },

    open() {
      this.dialog = true;
      this.form = {};
    },

    close() {
      this.dialog = false;
    },

    save() {
      this.$emit('save', this.form);
    },
  },
};
</script>
